import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage/HomePage';
import LoginPage from '../pages/LoginPage/LoginPage';
import NotFoundPage from '../pages/NotFoundPage';
import AccountSetupPage from '../pages/AccountSetupPage/AccountSetupPage';
import NotificationsPage from '../pages/NotificationsPage/NotificationsPage';
import RegistrationPage from '../pages/RegistrationPage/RegistrationPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage/ForgotPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import WatchVimeoVideoPlayerPage from '../pages/WatchVimeoVideoPlayerPage/WatchVimeoVideoPlayerPage';
import WatchRumbleVideoPlayerPage from '../pages/WatchRumbleVideoPlayerPage/WatchRumbleVideoPlayerPage';
import ReferencesPage from '../pages/ReferencesPage/ReferencesPage';
import AccountTermsAndConditionsPage from '../pages/AccountTermsAndConditionsPage/AccountTermsAndConditionsPage';
import SelectVideoPlayerPage from '../pages/SelectVideoPlayerPage/SelectVideoPlayerPage';
import MyFavoriteReferencesPage from '../pages/MyFavoriteReferencesPage/MyFavoriteReferencesPage';
import WatchOdyseeVideoPlayerPage from '../pages/WatchOdyseeVideoPlayerPage/WatchOdyseeVideoPlayerPage';

const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/videos/gallery/:subjectId" element={<HomePage />} />
            <Route path="/videos/list/:videoId" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegistrationPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/password/reset" element={<ResetPasswordPage />} />
            <Route path="/account-setup" element={<AccountSetupPage />} />
            <Route path="/select/player/:videoId" element={<SelectVideoPlayerPage />} />
            <Route path="/watch/player1/:videoId" element={<WatchRumbleVideoPlayerPage />} /> {/* RUMBLE */}
            <Route path="/watch/player2/:videoId" element={<WatchOdyseeVideoPlayerPage />} /> {/* ODYSEE */}
            <Route path="/watch/player3/:videoId" element={<WatchVimeoVideoPlayerPage />} /> {/* VIMEO */}
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/references" element={<ReferencesPage />} />
            <Route path="/my-favorite-references" element={<MyFavoriteReferencesPage />} />
            <Route path="/terms" element={<AccountTermsAndConditionsPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutes;